module.exports = __webpack_public_path__ + "media/images/play-9ca849978ff19c984999b4fdae292d1d.png";